import React from 'react';
import AIcon from './_atoms.icon';
import { MLoader } from '../molecules';

export default function AImagePlaceholder({ loading = false }) {
	return (
		<div className="a-placeholder">
			{loading ?
				<MLoader className="article--loader-filters " />
				:
				<AIcon type="image" />
			}


		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.image-placeholder.js